import "./Legal.css";

export default function PrivacyPolicy() {
  return (
    <div className="legal-page">
      <h1>Política de Privacidade</h1>
      <p className="legal-date">Última atualização: 25 de março de 2026</p>

      <p>
        A presente Política de Privacidade descreve como o <strong>ViewsDay</strong> ("nós", "nosso" ou "Plataforma")
        coleta, utiliza, armazena e protege os dados pessoais dos usuários ("você" ou "Usuário"), em conformidade com a
        Lei Geral de Proteção de Dados Pessoais (Lei nº 13.709/2018 — LGPD), o Marco Civil da Internet
        (Lei nº 12.965/2014) e demais normas aplicáveis.
      </p>

      <h2>1. Dados Pessoais Coletados</h2>
      <p>Coletamos os seguintes dados pessoais quando você utiliza nossa Plataforma:</p>
      <ul>
        <li><strong>Dados de cadastro:</strong> endereço de e-mail e senha (armazenada de forma criptografada).</li>
        <li><strong>Preferências de uso:</strong> fuso horário, horário preferido de entrega dos resumos, canais do YouTube selecionados.</li>
        <li><strong>Dados de comunicação:</strong> número de telefone do WhatsApp e/ou identificador do Telegram, quando vinculados pelo Usuário.</li>
        <li><strong>Dados de navegação:</strong> informações armazenadas localmente no navegador (localStorage), como preferência de idioma e token de autenticação.</li>
        <li><strong>Dados de uso:</strong> registros de acesso (logs), conforme exigido pelo Marco Civil da Internet.</li>
      </ul>

      <h2>2. Finalidades do Tratamento</h2>
      <p>Seus dados pessoais são tratados para as seguintes finalidades:</p>
      <ul>
        <li>Criação e gerenciamento da sua conta na Plataforma.</li>
        <li>Entrega de resumos personalizados de vídeos do YouTube via WhatsApp, Telegram ou e-mail.</li>
        <li>Processamento de pagamentos e gestão de planos de assinatura.</li>
        <li>Comunicação sobre atualizações do serviço, alterações nos termos ou questões de segurança.</li>
        <li>Cumprimento de obrigações legais e regulatórias.</li>
        <li>Melhoria contínua da Plataforma e da experiência do Usuário.</li>
      </ul>

      <h2>3. Base Legal para o Tratamento</h2>
      <p>O tratamento dos seus dados pessoais é realizado com base nas seguintes hipóteses previstas no Art. 7º da LGPD:</p>
      <ul>
        <li><strong>Consentimento (Art. 7º, I):</strong> ao criar sua conta e aceitar esta Política.</li>
        <li><strong>Execução de contrato (Art. 7º, V):</strong> para a prestação dos serviços contratados.</li>
        <li><strong>Cumprimento de obrigação legal (Art. 7º, II):</strong> para atender exigências legais, como a guarda de registros de acesso.</li>
        <li><strong>Legítimo interesse (Art. 7º, IX):</strong> para melhorias no serviço e comunicações relevantes.</li>
      </ul>

      <h2>4. Compartilhamento de Dados</h2>
      <p>Seus dados podem ser compartilhados com os seguintes terceiros, estritamente para as finalidades descritas:</p>
      <ul>
        <li><strong>YouTube / Google:</strong> para acesso ao conteúdo dos canais selecionados por você (via YouTube Data API).</li>
        <li><strong>WhatsApp (Meta) / Telegram:</strong> para entrega dos resumos no canal de comunicação escolhido.</li>
        <li><strong>Provedores de inteligência artificial:</strong> para geração dos resumos de conteúdo (os dados enviados são limitados ao conteúdo público dos vídeos).</li>
        <li><strong>Processadores de pagamento:</strong> para gestão de cobranças e assinaturas.</li>
        <li><strong>Autoridades competentes:</strong> quando exigido por lei ou ordem judicial.</li>
      </ul>
      <p>Não vendemos, alugamos ou comercializamos seus dados pessoais com terceiros.</p>

      <h2>5. Armazenamento e Segurança</h2>
      <p>
        Seus dados são armazenados em servidores seguros com criptografia em trânsito (TLS/SSL) e em repouso.
        Senhas são armazenadas utilizando algoritmos de hash seguros. Adotamos medidas técnicas e organizacionais
        adequadas para proteger seus dados contra acesso não autorizado, destruição, perda ou alteração.
      </p>
      <p>
        Os registros de acesso são armazenados pelo prazo mínimo de 6 (seis) meses, conforme o Art. 15 do
        Marco Civil da Internet.
      </p>

      <h2>6. Cookies e Armazenamento Local</h2>
      <p>
        A Plataforma utiliza <strong>localStorage</strong> do navegador para armazenar sua preferência de idioma e
        token de autenticação (JWT). Não utilizamos cookies de rastreamento ou publicidade de terceiros.
      </p>

      <h2>7. Seus Direitos como Titular</h2>
      <p>Nos termos da LGPD (Art. 18), você tem direito a:</p>
      <ul>
        <li>Confirmar a existência de tratamento dos seus dados pessoais.</li>
        <li>Acessar seus dados pessoais.</li>
        <li>Corrigir dados incompletos, inexatos ou desatualizados.</li>
        <li>Solicitar a anonimização, bloqueio ou eliminação de dados desnecessários ou excessivos.</li>
        <li>Solicitar a portabilidade dos seus dados.</li>
        <li>Solicitar a eliminação dos dados tratados com base no consentimento.</li>
        <li>Obter informações sobre as entidades com as quais seus dados foram compartilhados.</li>
        <li>Revogar o consentimento a qualquer momento.</li>
      </ul>
      <p>
        Para exercer qualquer desses direitos, entre em contato conosco pelos canais indicados na seção "Contato" abaixo.
      </p>

      <h2>8. Retenção de Dados</h2>
      <p>
        Seus dados pessoais serão mantidos enquanto sua conta estiver ativa ou conforme necessário para cumprir
        obrigações legais. Após o encerramento da conta, os dados serão eliminados no prazo de 30 (trinta) dias,
        exceto aqueles que devam ser mantidos por exigência legal.
      </p>

      <h2>9. Transferência Internacional de Dados</h2>
      <p>
        Alguns dos nossos prestadores de serviço podem estar localizados fora do Brasil. Nesses casos, a transferência
        internacional de dados é realizada em conformidade com o Art. 33 da LGPD, com a adoção de garantias adequadas
        de proteção de dados.
      </p>

      <h2>10. Alterações nesta Política</h2>
      <p>
        Podemos atualizar esta Política de Privacidade periodicamente. Notificaremos você sobre alterações
        significativas por e-mail ou por aviso na Plataforma. O uso continuado do serviço após a publicação
        de alterações constitui sua aceitação da Política atualizada.
      </p>

      <h2>11. Contato</h2>
      <div className="legal-contact">
        <p><strong>ViewsDay</strong></p>
        <p>E-mail para questões de privacidade: <a href="mailto:contact@views-day.com">contact@views-day.com</a></p>
        <p>
          Caso não tenha sua solicitação atendida de forma satisfatória, você pode apresentar reclamação perante a
          Autoridade Nacional de Proteção de Dados (ANPD).
        </p>
      </div>
    </div>
  );
}
